import { counters } from './counters';
import { commonUtils } from './common_utils';

export const compareAd = {
    cookieExpireTime: 365 * 24 * 60, // Time into minutes
    cookieName: '_compare_ads',
    dataLayerEventName: 'addedToComparisonList',
    maxLength: 10,
    elementToAddSelectedClass: '',
    animating: false,
    pageName: 'listing',
    selectedClassName: '',
    url: Routing.generate('compare_ad_add'),
    maxLengthGuestUser: 2,

    init(opts) {
        this.maxLength = opts.maxLength ? opts.maxLength : this.maxLength;
        this.elementToAddSelectedClass = opts.elementToAddSelectedClass;
        this.animating = opts.animating;
        this.pageName = opts.pageName ? opts.pageName : this.pageName;
        this.selectedClassName = opts.selectedClassName;
        this.url = opts.url ? opts.url : this.url;
        this.maxLengthGuestUser = opts.maxLengthGuestUser ? opts.maxLengthGuestUser : this.maxLengthGuestUser;
    },
    async add(id) {
        try {
            await this.getForSaleAds();
        } catch (_error) {
            return false;
        }
        let cookieAdIds = this.getCookie();

        if (!commonUtils.isUserLogin() && cookieAdIds.length >= this.maxLengthGuestUser) {
            window.$.colorbox({ inline: true, href: '#compareAdLimit' });
            return false;
        }

        // If same id not exist in Cookie then Enter id into Cookie
        if (cookieAdIds.indexOf(id) === -1) {
            if (cookieAdIds.length === this.maxLength) {
                alert(Translations.compare.limit);
                return false;
            }

            cookieAdIds.push(id);
            this.setCookie(cookieAdIds);
            this.incrementCounter();
            $(this.elementToAddSelectedClass).addClass(this.selectedClassName);
        }

        commonUtils.dataLayer.genericDataLayerEvent(this.dataLayerEventName);
        return true;
    },
    setCookie(data) {
        commonUtils.setCookie(this.cookieName, JSON.stringify(data), this.cookieExpireTime);
    },
    getCookie() {
        let cookieData = commonUtils.getCookie(this.cookieName);
        let value = cookieData ? JSON.parse(cookieData) : [];
        return value ? value.map((item) => Number(item)) : [];
    },
    incrementCounter() {
        let pageType = this.pageName === 'viewAd' ? 'vif' : 'listing';
        counters.incrementByType(`${pageType}-compare-mobile`);
    },
    setForSaleAdsCookie(data) {
        compareAd.setCookie(data.adIds);
    },
    getForSaleAds() {
        // Cookie value send in each request so no need to send as value in this request
        return new Promise((resolve, reject) => {
            $.post(this.url, '', function (data) {
                compareAd.setForSaleAdsCookie(data);
                resolve();
            }).fail(function (error) {
                reject(error);
            });
        });
    },
    remove(id) {
        let cookieAdIds = this.getCookie();
        let index = cookieAdIds.indexOf(id);
        if (index > -1) {
            cookieAdIds.splice(index, 1);
        }

        this.setCookie(cookieAdIds);
    },
    removeAll() {
        if (confirm(Translations.compare.remove_all)) {
            commonUtils.deleteCookie(this.cookieName);
            return true;
        }

        return undefined;
    },
    getTotalAds() {
        return this.getCookie().length;
    },
    openCompareModal() {
        let compareAdIds = this.getCookie();
        if (compareAdIds.length === 0) {
            return false;
        }

        document.documentElement.style.overflow = 'hidden'; // firefox, chrome
        document.body.scroll = 'no'; // ie only

        $.colorbox({
            href: Routing.generate('compare_ad_list'),
            close: '',
            fixed: true,
            height: $(window).height(),
            width: $(window).width(),
            onComplete() {
                $('.moveCompareAdToLeft:first, .moveCompareAdToRight:last').hide();
                let $uiStateDefault = $('.compareAdListBlock');
                let sortableWidth = $uiStateDefault.width() * $uiStateDefault.length + 111;
                $('#sortable').css({ width: sortableWidth });

                // Set height for individual li
                $('[id^=adDetails]:eq(0) ul li').each(function () {
                    let linum = $('[id^=adDetails]:eq(0) ul li').index(this);

                    let maxHeight = -1;
                    let $adDetailsUl = $('[id^=adDetails] ul');
                    $adDetailsUl.each(function () {
                        let $this = $(this).find(`li:eq(${linum})`);
                        maxHeight = maxHeight > $this.height() ? maxHeight : $this.height();
                    });

                    $adDetailsUl.each(function () {
                        $(this).find(`li:eq(${linum})`).height(maxHeight);
                    });

                    $(`#ad_header li:eq(${linum})`).height(maxHeight);
                });

                $('#compareModalBox, .compare_modal_box_nl').width($(window).width()).height($(window).height());
                $('#compare_list_nl').css({ height: $(window).height() - 50 });
                if (compareAdIds.length === 1) {
                    $('.top_img_box').css({ 'margin-top': 0 });
                }

                if (!commonUtils.isMobileView()) {
                    compareAd.sortable();
                }

                compareAd.disableSelection();
                compareAd.orientationchange();
            },
            onClosed() {
                if (compareAd.getTotalAds() > 0) {
                    $('.compareCounter, .compareAdCounter').html(`(${compareAd.getTotalAds()})`);
                } else {
                    $('.product-card__add-to-compare').removeClass('product-card__add-to-compare_added');
                    $('.compareAdLink').hide();
                }
            },
        });

        return undefined;
    },
    moveToRight(element) {
        if (this.animating) {
            return true;
        }

        let ele = $(element).parents('.ui-state-default');
        let nextEle = ele.next();
        let distance = ele.width();
        if (nextEle.length) {
            this.animating = true;
            $.when(
                ele.animate({ right: -distance, opacity: 0.5 }, 500),
                nextEle.animate({ right: distance, opacity: 0.5 }, 500)
            ).done(function () {
                ele.insertAfter(nextEle);
                nextEle.css({ right: '0px', opacity: '1' });
                ele.css({ right: '0px', opacity: '1' });

                $('.moveCompareAdToLeft, .moveCompareAdToRight').show();
                $('.moveCompareAdToLeft:first, .moveCompareAdToRight:last').hide();
                compareAd.animating = false;
            });
        }

        return undefined;
    },
    moveToLeft(element) {
        if (this.animating) {
            return true;
        }

        let ele = $(element).parents('.ui-state-default');
        let prevEle = ele.prev();
        let distance = ele.width();
        if (prevEle.length) {
            this.animating = true;
            $.when(
                ele.animate({ left: -distance, opacity: 0.5 }, 500),
                prevEle.animate({ left: distance, opacity: 0.5 }, 500)
            ).done(function () {
                ele.insertBefore(prevEle);
                prevEle.css({ left: '0px', opacity: '1' });
                ele.css({ left: '0px', opacity: '1' });

                $('.moveCompareAdToLeft, .moveCompareAdToRight').show();
                $('.moveCompareAdToLeft:first, .moveCompareAdToRight:last').hide();
                compareAd.animating = false;
            });
        }

        return undefined;
    },
    sortable() {
        $('#sortable').sortable({
            opacity: 0.5,
            axis: 'x',
            cursor: 'move',
            revert: true,
            scrollSensitivity: 100,
            scrollSpeed: 10,
            tolerance: 'pointer',
            stop() {
                $('.moveCompareAdToLeft, .moveCompareAdToRight').show();
                $('.moveCompareAdToLeft:first, .moveCompareAdToRight:last').hide();
            },
        });
    },
    orientationchange() {
        $(window).on('orientationchange resize', function () {
            if ($('#compareModalBox').is(':visible')) {
                $.colorbox.resize({ width: $(window).width(), height: $(window).height() });
                $('#compareModalBox')
                    .width($(window).width())
                    .height($(window).height())
                    .css('overflow', 'auto!important');
                $('#compare_list_nl').css({ height: $(window).height() - 50 });
            }
        });
    },
    disableSelection() {
        $('#sortable').disableSelection();
    },
    removeForListing(element) {
        element
            .text(Translations.compare.title)
            .prop('title', Translations.compare.add)
            .removeClass('product-card__add-to-compare_added');
    },
};

$(function () {
    commonUtils.colorBoxEvent();
    let $body = $('body');
    // Listing pages: add,remove ad from compare list
    $body.on('click', '.compareAd', async function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        compareAd.init({
            elementToAddSelectedClass: $(this),
            selectedClassName: 'product-card__add-to-compare_added',
            pageName: $(this).closest('.product-card').data('pagename'),
        });

        if ($(this).hasClass('product-card__add-to-compare_added')) {
            compareAd.remove($(this).data('adid'));
            compareAd.removeForListing($(this));
            // Show the "Hide from search" button when removing from compare, but only if ad is not in favorites
            let $productCard = $(this).closest('.product-card');
            let isFavorite = $productCard.find('.addToFavouriteList').hasClass('product-card__ad-to-fav_added');
            if (!isFavorite) {
                $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').removeClass('none');
            }
        } else if (await compareAd.add($(this).data('adid'))) {
            $(this).prop('title', Translations.compare.remove);
            $(this).text(Translations.compare.added_to_compare_listing);
            // Hide the "Hide from search" button when adding to compare
            let $productCard = $(this).closest('.product-card');
            $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').addClass('none');
            // compareAdLink element in favourite ad, dealer favourite ad
            let $compareAdLink = $('.compareAdLink');
            if ($compareAdLink.length > 0) {
                $compareAdLink.addClass('show-compare-counter_animation');
                setTimeout(function () {
                    $('.compareAdLink').removeClass('show-compare-counter_animation');
                }, 1000);
            }
        }

        let $showCompareElement = $('.page-features__show-compare,.sub-header-mobile__show-compare_open');
        if (compareAd.getTotalAds()) {
            // For sticky header link
            $showCompareElement.css('display', 'flex');
            $showCompareElement.addClass('sub-header-mobile__show-compare_open-viewed');
            // For compare button in favourite ad, dealer favourite ad
            $('.compareAdLink').show();
            $('.compareAdCounter').html(`(${compareAd.getTotalAds()})`);
        } else {
            $showCompareElement.css('display', 'none');
            $showCompareElement.removeClass('sub-header-mobile__show-compare_open-viewed');
            $('.compareAdLink').hide();
        }
    });

    // Open compare ad popup from listing page
    $body.on('click', '.openCompareList', function () {
        compareAd.init({});
        compareAd.openCompareModal();
    });

    // Remove all ads from compare list
    $body.on('click', '.removeAllCompareAds', function () {
        compareAd.init({});
        if (compareAd.removeAll()) {
            // Remove class for vif page and change caption
            $('.addToCompareFromVif')
                .html(Translations.add_compare_single)
                .removeClass('page-features__show-compare_open sub-header-mobile__show-compare_open showCompareOpen');
            $('.addToCompareFromVifSticky').html(Translations.add_to_compare_single_line);
            $('.addToCompareFromVifImage')
                .removeClass('item-compare-added')
                .prop('title', Translations.add_to_compare_single_line);

            // Remove class for listing page
            compareAd.removeForListing($('#listingData').find('.product-card__add-to-compare'));

            // Hide "show compare" link in sticky header for listing page
            $('.page-features__show-compare,.sub-header-mobile__show-compare_open').not('.addToCompareFromVif').hide();
            $.colorbox.close();
        }
    });

    // Remove single ad from compare ad modal
    $body.on('click', '.removeCompareAd', function () {
        compareAd.init({});
        let compareAdId = $(this).data('adid');
        compareAd.remove(compareAdId);

        // Remove class for vif page
        if ($('.addToCompareFromVif').data('ad-id') === compareAdId) {
            $('.addToCompareFromVif')
                .html(Translations.add_compare_single)
                .removeClass('page-features__show-compare_open sub-header-mobile__show-compare_open showCompareOpen');
            $('.addToCompareFromVifSticky').html(Translations.add_to_compare_single_line);
            $('.addToCompareFromVifImage')
                .removeClass('item-compare-added')
                .prop('title', Translations.add_to_compare_single_line);
        }
        // Remove class for listing page
        compareAd.removeForListing($(`#compareAd${compareAdId}`));

        let totalComparesAds = compareAd.getTotalAds();
        $(`#adDetails${compareAdId}`).remove();
        $('.compareCounter').html(totalComparesAds);

        if (totalComparesAds <= 0) {
            // Hide "show compare" link in sticky header for listing page
            $('.page-features__show-compare,.sub-header-mobile__show-compare_open').not('.addToCompareFromVif').hide();
            $.colorbox.close();
        }

        $('.moveCompareAdToLeft:first, .moveCompareAdToRight:last').hide();
    });

    // Move compare ad to left/right in compare ad modal
    $body.on('click', '.moveCompareAdToRight', function () {
        compareAd.init({});
        compareAd.moveToRight($(this));
    });

    // Move compare ad to left in compare ad modal
    $body.on('click', '.moveCompareAdToLeft', function () {
        compareAd.init({});
        compareAd.moveToLeft($(this));
    });
});
